import Guid from "devextreme/core/guid";
import { convertDateFormat } from "../../utils/dateUtils";
import { FETCH_SERVICE_DATES } from "./services/fetch-service-dates-from-cases";
import { HIDE_LOADER } from "../mdae-common-reducer";
import { callOperation } from "async-ops";
import { showNotifyPopup } from "../common-functions";

export const formatAiSummaryText = (
  summaryText: string | null | undefined
): string => {
  if (!summaryText) return "";

  return summaryText
    .split(/\n\s*\n/) // split paragraphs
    .map((para) => {
      const lines = para.trim().split("\n");

      const processedLines = lines.map((line) => {
        let updatedLine = line;

        //Make anything inside ** ** bold
        updatedLine = updatedLine.replace(
          /\*\*(.*?)\*\*/g,
          "<span style='font-weight:bold;'>$1</span>"
        );

        //Bold numbered section titles (e.g., "1. Highlights:")
        updatedLine = updatedLine.replace(
          /^(\d+\.\s.*?:)/,
          "<span style='font-weight:bold;'>$1</span>"
        );
        //Bold bullet point heading (before first "for" or from start till first number/colon/comma)
        updatedLine = updatedLine.replace(
          /^(\s*-\s*)([^:]+?)(?=\s(for|is|shows|spiked|dropped|declined|reached|improved|across|demonstrates|underscores|$))/i,
          (match, bullet, text) =>
            `${bullet}<span style='font-weight:bold;'>${text.trim()}</span>`
        );

        return updatedLine;
      });

      const firstLine = processedLines[0];
      const rest = processedLines.slice(1).join("<br/>");

      //Added spacing for readability
      return `<p style="line-height:1.6; margin-bottom:10px;">${firstLine}${
        rest ? "<br/>" + rest : ""
      }</p>`;
    })
    .join("");
};
export const createAuditFromRevenueRiskLiveboard = async (
  dispatch,
  payload,
  currentUser
) => {  
  let accountNumberList = Array.isArray(payload)
    ? payload
    : JSON.parse(payload); // If it was accidentally passed as a string
  if (accountNumberList.length > 0) {    
    const result = await callOperation(FETCH_SERVICE_DATES, {
      accountNumberList,
    });

    let serviceFrom = "";
    let serviceTo = "";
    console.log("result from fetch service dates:", result);
    if (
      result &&
      result.serviceFromDate !== "0001-01-01T00:00:00" &&
      result.serviceToDate !== "0001-01-01T00:00:00"
    ) {
      serviceFrom = convertDateFormat(result.serviceFromDate, "MM/DD/YYYY");
      serviceTo = convertDateFormat(result.serviceToDate, "MM/DD/YYYY");
      let param = {
        key: new Guid().toString(),
        auditTitle:
          "Denial Risks Audit - " + convertDateFormat(new Date(), "MM/DD/YYYY"),
        statementFromDate: serviceFrom,
        statementToDate: serviceTo,
        accountNumberList: accountNumberList,
        userId: currentUser.userId,
        sampleSize: 0,
        dataType: result.dataType,
        claimType:result.claimType
      };
      // Save to local storage
      localStorage.removeItem("Denial_Risks_Account_Cookie");
      localStorage.setItem(
        "Denial_Risks_Account_Cookie",
        JSON.stringify(param)
      );
      dispatch({ type: HIDE_LOADER, });
      // Navigate to audit page in new tab
      const newWindow = window.open("");
      if (newWindow) {
        newWindow.location.href =
          window.location.origin +
          "/audit/newaudit/?hasServiceDates=false&revenueRiskAccountKey=" +
          param.key;
      }
    } else {
      dispatch({ type: HIDE_LOADER, });
      showNotifyPopup(dispatch, "Cases not found for selected accounts.");       
      return;
    }
  } else {
    dispatch({ type: HIDE_LOADER, });
    showNotifyPopup(dispatch, "Cases not found for selected accounts.");
    
    return;
  }
};
